import { render, staticRenderFns } from "./SkinToolbarNotificator.vue?vue&type=template&id=3c50830f&scoped=true"
import script from "./SkinToolbarNotificator.vue?vue&type=script&lang=js"
export * from "./SkinToolbarNotificator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50830f",
  null
  
)

export default component.exports